import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import Checkbox from "rc-checkbox";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";

const renderTags = (cell, row, type) => {
  if (row?.[type] !== undefined) {
    if (typeof row[type] === "string") {
      return row[type];
    } else if (Array.isArray(row[type])) {
      return row[type].join(", ");
    } else {
      return cell;
    }
  }
};

class CampaignPacingTopContent extends PureComponent {
  state = { networks: ["all"] };

  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable = (data) => {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "300px", minWidth: "300px", textAlign: "left" },
        headerAlign: "left",
        headerClasses: "sticky-column",
        classes: "sticky-column",

        formatter: TableContentCell,
        formatExtraData: { showDate: false },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "published_date",
        text: "Publish Date",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell, row) => selectFormat("date", cell),
        csvFormatter: (cell) => {
          if (cell) {
            return selectFormat("date", cell);
          }
        },
        sort: true,
        sortFunc: (a, b, order) =>
          order === "desc" ? (a > b ? 1 : -1) : b > a ? 1 : -1,
      },
      {
        dataField: "reach",
        text: "Reach",
        style: { width: "85px", minWidth: "85px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_title",
        text: "Title",
        style: { width: "85px", minWidth: "85px" },
        sort: true,
      },
      {
        dataField: "network",
        text: "Platform",
        style: { width: "100px", minWidth: "100px" },
        csvFormatter: (cell, row) =>
          row && row.network.charAt(0).toUpperCase() + row.network.slice(1),
        csvExport: true,
        sort: true,
      },
      {
        dataField: "type",
        text: "Type",
        style: { width: "100px", minWidth: "100px" },
        csvExport: true,
        sort: true,
      },
      {
        dataField: "permalink",
        style: { width: "100px", minWidth: "100px" },
        text: "Post URL",
        hidden: true,
        csvExport: true,
      },
      {
        dataField: "hashtags",
        text: "Hashtags",
        csvExport: true,
        style: { width: "100px", minWidth: "100px" },
        csvFormatter: (cell, row) => row && row.hashtags,
        formatter: (cell, row) => renderTags(cell, row, "hashtags"),
        sort: true,
      },
      {
        dataField: "handle",
        text: "Handle",
        csvFormatter: (cell) => cell,
        style: { width: "100px", minWidth: "100px" },
        sort: true,
      },
      {
        dataField: "handles",
        text: "Handle",
        style: { width: "100px", minWidth: "100px" },
        csvFormatter: (cell, row) => renderTags(cell, row, "handles"),
        sort: true,
      },
      {
        dataField: "lifetime_reach",
        text: "Ltd Reach",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_comments",
        text: "Ltd Comments",
        style: { width: "125px", minWidth: "125px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "content_id",
        text: "Content ID",
        style: { width: "65px", minWidth: "65px" },
        csvFormatter: (cell) => cell,
        sort: true,
      },
      {
        dataField: "lifetime_likes",
        text: "Ltd Likes",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_reactions",
        text: "Ltd Reactions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_shares",
        text: "Ltd Shares",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_saves",
        text: "Ltd Saves",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_engagement",
        text: "Ltd Engagements",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "actions",
        text: "Actions",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement",
        text: "Engagements",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement_rate",
        text: "Eng Rate",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "comments",
        text: "Comments",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "likes",
        text: "Likes",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "reactions",
        text: "Reactions",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "shares",
        text: "Shares",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "saves",
        text: "Saves",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "link_clicks",
        text: "Link Clicks",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "post_time",
        text: "Post Time",
        hidden: true,
      },

      {
        dataField: "url",
        text: "URL",
        hidden: true,
      },

      {
        dataField: "lifetime_impressions",
        text: "Ltd Impressions",
        style: { width: "115px", minWidth: "115px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "lifetime_impressions_organic",
        text: "Ltd Impressions (Organic)",
        style: { width: "165px", minWidth: "165px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "impressions_organic",
        text: "Impressions (Organic)",
        style: { width: "145px", minWidth: "145px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "view_rate",
        text: "View Rate",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "view_time",
        text: "View Time",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "unique_viewers",
        text: "Unique Viewers",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "lifetime_views",
        text: "Ltd Views",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "completion",
        text: "Completion",
        style: { width: "135px", minWidth: "135px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    let sortField = "published_date";
    if (url.includes("world-cup-reels-content")) {
      sortField = "engagement";
    } else if (url.includes("yes-network/viewing-top-content")) {
      sortField = "unique_viewers";
    } else if (
      url.includes("world-cup-tiktok-content") ||
      url.includes("world-cup-top-posts") ||
      url.includes("social-events-top-posts")
    ) {
      sortField = "views";
    }

    const defaultSorted = [
      {
        dataField: sortField,
        order: "desc",
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={pagination}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  onChange = (e) => {
    let NAME = e.target.name;
    e.target.checked ? this.addItem(NAME) : this.removeItem(NAME);
  };

  onChangeAll = (e) => {
    this.setState({
      networks: ["all"],
    });
  };

  addItem = (item) => {
    this.setState({
      networks: [...this.state.networks.filter((i) => i !== "all"), item],
    });
  };

  removeItem = (item) => {
    const NETWORKS = this.state.networks.filter((i) => i !== item);
    this.setState({
      networks: NETWORKS.length === 0 ? ["all"] : NETWORKS,
    });
  };

  renderFilters = (data) => {
    const NETWORKS_ORDER = [
      "facebook",
      "instagram",
      "twitter",
      "tiktok",
      "youtube",
    ];
    let networks = [...new Set(data.map((o) => o.network))];

    networks.sort((a, b) => {
      const networsOrder = NETWORKS_ORDER.map((network) =>
        network.toLowerCase()
      );

      const indexA = networsOrder.includes(a.toLowerCase())
        ? networsOrder.indexOf(a.toLowerCase())
        : networsOrder.length;
      const indexB = networsOrder.includes(b.toLowerCase())
        ? networsOrder.indexOf(b.toLowerCase())
        : networsOrder.length;

      return indexA - indexB;
    });

    if (networks.length > 1) {
      const checkboxes = networks.map((item) => (
        <label key={item} className="filters__checkbox_label">
          <Checkbox
            name={item}
            checked={this.state.networks.includes(item)}
            onChange={this.onChange}
          />
          <span className="filters__checkbox_label-text">{item}</span>
        </label>
      ));

      return (
        <div className="row">
          <div className="col-12">
            <section className="filters">
              <label className="filters__checkbox_label">
                <Checkbox
                  name="all"
                  checked={this.state.networks.includes("all")}
                  onChange={this.onChangeAll}
                />
                <span className="filters__checkbox_label-text">Everything</span>
              </label>
              {checkboxes}
            </section>
          </div>
        </div>
      );
    }
  };

  sortByViews50 = (data) =>
    data.sort((a, b) => b.reach.value - a.reach.value).slice(0, 2000);

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.data;
    const networks = this.state.networks;

    if (this.props.data.hasData === false) {
      return <Error minHeight={200} />;
    }

    let table_data = data;

    if (!networks.includes("all")) {
      let filters = this.state.networks;
      table_data = data.filter((o) => filters.includes(o.network));
    }

    return (
      <>
        {this.renderFilters(data)}
        {this.renderTable(table_data)}
      </>
    );
  }
}

export default CampaignPacingTopContent;
